import { CnButton, CnIcon, CnMessage } from '@alife/cn-ui';
import { useI18n } from '@alife/panda-i18n';
import React, { useEffect, useRef, useState } from 'react';
import { getDetail, userFeedback } from 'src/services';
import { useImgPreviewByRef } from 'src/hooks';
import { logCustom, logError } from 'src/utils/tracker';
import Loading from 'src/view/components/loading';
import Result from 'src/view/components/result';
import Header from '../header';
import './index.scss';
export default function HotDetail(props) {
    const { onBack, panelCode, userId, id, hasOnlineService, openOnlineService } = props;
    // console.log('props', props);
    const $i18n = useI18n();
    const [data, setData] = useState(props.data || null);
    const htmlRef = useRef(null);
    const [loading, setLoading] = useState(props.data ? false : true);
    const [useful, setUseful] = useState('');
    useEffect(() => {
        logCustom('EXP_hotQuestionDetail', id, panelCode);
        // console.log('data?.answer', data?.answer, props);
    }, []);
    const init = async () => {
        try {
            setLoading(true);
            const data = await getDetail({ questionId: id, panelCode, userId });
            setData(data);
        }
        catch (error) {
            logError(error, {
                c1: 'knowledge detail load fail',
                c2: id,
            });
        }
        setLoading(false);
    };
    useEffect(() => {
        if (!data) {
            init();
        }
    }, []);
    useImgPreviewByRef(htmlRef, data?.answer);
    // console.log('htmlRef', htmlRef);
    const [evaluateState, setEvaluateState] = useState('init');
    const disabledEvaluateBtn = evaluateState !== 'init';
    const onClickBtn = async (value) => {
        if (evaluateState !== 'init')
            return;
        setEvaluateState('during');
        try {
            await userFeedback({
                value,
                panelCode,
                userId: props.userId,
                userName: props.userName,
                accountType: props.userSystem,
                knowledgeId: data?.id,
                type: 'knowledgeAppraised',
            });
            setUseful(value);
            CnMessage.success({
                content: $i18n.get({ id: 'OperationSuccessful', dm: '操作成功' }),
            });
            setEvaluateState('finish');
        }
        catch (error) {
            CnMessage.error({
                content: error.errorMsg ||
                    $i18n.get({
                        id: 'OperationFailedPleaseTryAgain',
                        dm: '操作失败 请重试',
                    }),
            });
            setEvaluateState('init');
        }
    };
    return (React.createElement("div", { className: `cn-ui-intelli-assistant-hot-detail` },
        React.createElement(Header, { onClick: onBack, title: $i18n.get({ id: 'HotIssues.ued', dm: '热点问题' }) }),
        loading ? (React.createElement(Loading, { visible: loading })) : data ? (React.createElement("div", { className: 'cn-ui-intelli-assistant-hot-detail-body' },
            React.createElement("div", { className: 'cn-ui-intelli-assistant-hot-detail-title' }, data?.title),
            React.createElement("div", { className: 'cn-ui-intelli-assistant-hot-detail-sub-title' },
                $i18n.get({
                    id: '31255238652596224.CNTM',
                    dm: '更新时间',
                }),
                ' ',
                ": ",
                data?.gmtModified),
            React.createElement("div", { className: 'cn-ui-intelli-assistant-hot-detail-content', ref: htmlRef, dangerouslySetInnerHTML: { __html: data?.answer } }),
            React.createElement("div", { className: 'cn-ui-intelli-assistant-hot-detail-operate' },
                React.createElement("div", { className: 'cn-ui-intelli-assistant-hot-detail-operate-btn-group' },
                    React.createElement(CnButton, { type: 'normal', disabled: disabledEvaluateBtn, className: 'cn-ui-intelli-assistant-hot-detail-operate-btn-group-btn', size: 'small', onClick: () => onClickBtn('useful') },
                        React.createElement(CnIcon, { type: 'good', outerClassName: 'cn-ui-intelli-assistant-hot-detail-operate-btn-group-btn-icon' }),
                        $i18n.get({ id: 'Useful', dm: '有用' })),
                    React.createElement(CnButton, { type: 'normal', disabled: disabledEvaluateBtn, className: 'cn-ui-intelli-assistant-hot-detail-operate-btn-group-btn', size: 'small', onClick: () => onClickBtn('unuseful') },
                        React.createElement(CnIcon, { type: 'good', outerClassName: 'cn-ui-intelli-assistant-hot-detail-operate-btn-group-btn-icon turn-out' }),
                        $i18n.get({ id: 'Useless', dm: '无用' }))),
                hasOnlineService && useful === 'unuseful' ? (React.createElement("div", { className: 'cn-ui-intelli-assistant-hot-detail-operate-online-btn-area' },
                    React.createElement(CnButton, { type: 'primary', className: 'cn-ui-intelli-assistant-hot-detail-operate-online-btn', onClick: () => openOnlineService({
                            extraBailingConfig: JSON.stringify({
                                initMessage: data.title,
                            }),
                        }) }, $i18n.get({ id: 'OnlineServiceTitle', dm: '在线服务' })))) : null))) : (React.createElement(Result, { type: 'error', subTitle: $i18n.get({
                id: 'LoadFailedPleaseTryAgainLater_1651032900',
                dm: '加载失败， 请稍后重试',
            }), extra: React.createElement(CnButton, { onClick: init }, $i18n.get({ id: 'ClickRetry', dm: '点击重试' })) }))));
}
